import * as envUtils from 'utils/envUtils'
import {setFavicon} from 'utils/browserUtils'
import {getTheme} from './utils'

const brandTheme = getTheme(envUtils.isBrowser() ? window : null)

setFavicon(brandTheme.brand.favicon)

const theme = {
  ...brandTheme,
  breakpoints: {
    smallMobile: 0,
    minMobile: 375,
    middleMobile: 400,
    mobile: 481,
    portrait: 768,
    landscape: 1024,
    desktop: 1440,
  },
}

export default theme
